export const scrollToBottom = () => {
  const element = document.getElementById("message-scroll-view");
  if (!element) return;
  element.scrollTop = element.scrollHeight;
};

export const isMessageBoxActive = () => {
  const tiptapMessageBox = document.getElementById("tiptapMessageTextBox");
  return tiptapMessageBox === document.activeElement;
};
